module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/3-5bff76b28101a22b666a6815488fe5e9.svg";